import React, {Component, Fragment} from "react";
import "./../assets/style/feed.scss"
import request from './../assets/images/icons/ask.png'
import propose from './../assets/images/icons/business-proposal.png'
import Avatar from "@mui/material/Avatar";
import {Checkbox, FormControlLabel, Stack, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

class PostComponent extends Component{
    state = {
        setRequestOpen:false,
        setProposeOpen:false,
    }

    OpenRequestDialog = ()=>{
        this.setState({
            setRequestOpen:true,
        })
    }

    OpenProposeDialog = ()=>{
        this.setState({
            setProposeOpen:true,
        })
    }

    handleClose = () => {
        this.props.propsRequestValues.title=""
        this.props.propsRequestValues.amount=""
        this.props.propsRequestValues.length=1
        this.props.propsRequestValues.comment=""
        this.props.propsRequestValues.image=""
        this.setState({
            setRequestOpen:false,
            setProposeOpen:false,
        })
    };

    submitRequest = ()=>{
        this.props.handleRequestSubmit()
        this.handleClose()
    }

    submitProposal = ()=>{
        this.props.handleProposalSubmit()
        this.handleClose()
    }
    render() {
        return(
            <Fragment>
                <div className="card">
                    <div className="statusPost">
                        <div className="statusPost-avatar">
                            <Avatar
                                alt="Profile Pic"
                                src={this.props.profile.avatar}
                                sx={{ width: 30, height: 30 }}
                            />
                        </div>
                        <div>
                            <Box
                                sx={{
                                    width: 500,
                                    maxWidth: '100%',
                                }}
                            >
                                <TextField
                                    size="normal"
                                    fullWidth label="Start writing your message here..."
                                    id="fullWidth"
                                    onChange={(e)=>this.props.onChangeValue(e,'comment')}
                                    value={this.props.propsRequestValues.comment}
                                />
                            </Box>
                        </div>
                    </div>
                    <div className="statusPost-footer">
                        <Stack direction="row" spacing={3} justifyContent="center" mb={2}>
                            <Button
                                variant="outlined"
                                startIcon={<img height="20" src={request} alt='<a href="https://www.flaticon.com/free-icons/askcom" title="ask.com icons">Ask.com icons created by sonnycandra - Flaticon</a>"' />}
                                onClick={this.OpenRequestDialog}
                            >
                                Request
                            </Button>
                            <Button
                                variant="outlined"
                                startIcon={<img height="20" src={propose} alt='<a href="https://www.flaticon.com/free-icons/proposal" title="proposal icons">Proposal icons created by juicy_fish - Flaticon</a>'/>}
                                onClick={this.OpenProposeDialog}
                            >
                                Propose
                            </Button>
                        </Stack>
                    </div>
                </div>

                <Dialog
                    open={this.state.setRequestOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Share your request...
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Provide a detail explanation about why you need this loan
                        </DialogContentText>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '55ch' },
                            }}
                            noValidate
                            autoComplete="true"
                        >
                            <TextField
                                label="Title"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.title}
                                size="small"
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"title")}
                            />
                        </Box>
                        <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                            <InputLabel id="demo-select-small">Amount</InputLabel>
                            <Select
                                labelId="demo-select-small"
                                id="demo-select-small"
                                label="Amount"
                                value={this.props.propsRequestValues.amount}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"amount")}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {
                                    (this.props.propsRequestValues.availableAmounts).map(amount=>(
                                        <MenuItem key={amount.id} value={amount.amount}>{amount.amount}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="true"
                        >
                            <TextField
                                label="Length of loan in month(s)"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.length}
                                size="small"
                                type={"number"}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"length")}
                            />
                            <TextField
                                label="Image"
                                id="outlined-size-small"
                                type={"file"}
                                size="small"
                                onChange={(e)=>this.props.onChangeValue(e,"image")}
                            />
                        </Box>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '55ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Reason"
                                    multiline
                                    rows={3}
                                    onChange={(e)=>this.props.onChangeValue(e,'comment')}
                                    value={this.props.propsRequestValues.comment}
                                />
                            </div>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>Cancel</Button>
                        <Button onClick={this.submitRequest} autoFocus>
                            Post
                        </Button>
                    </DialogActions>
                </Dialog>



                <Dialog
                    open={this.state.setProposeOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Share your proposal...
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Provide an offer to anyone in need
                        </DialogContentText>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '55ch' },
                            }}
                            noValidate
                            autoComplete="true"
                        >
                            <TextField
                                label="Title"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.title}
                                size="small"
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"title")}
                            />
                        </Box>
                        <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                            <InputLabel id="demo-select-small">Amount</InputLabel>
                            <Select
                                labelId="demo-select-small"
                                id="demo-select-small"
                                label="Amount"
                                value={this.props.propsRequestValues.amount}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"amount")}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {
                                    (this.props.propsRequestValues.allAmounts).map(amount=>(
                                        <MenuItem key={amount.id} value={amount.amount}>{amount.amount}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '27ch' },
                            }}
                            noValidate
                            autoComplete="true"
                        >
                            <TextField
                                label="Length of loan (months)"
                                id="outlined-size-small"
                                type={"number"}
                                value={this.props.propsRequestValues.length}
                                size="small"
                                required
                                InputProps={{
                                    inputProps: {
                                        min: 1, max: 60
                                    }
                                }}
                                onChange={(e)=>this.props.onChangeValue(e,"length")}
                            />
                            <TextField
                                label="Rate (%)"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.rate}
                                size="small"
                                type={"number"}
                                InputProps={{
                                    inputProps: {
                                        min: 1, max: 99
                                    }
                                }}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"rate")}
                            />
                            <TextField
                                label="Monthly Payment ($)"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.payment}
                                type={"number"}
                                size="small"
                                disabled
                                onChange={(e)=>this.props.onChangeValue(e,"payment")}
                            />
                            <TextField
                                label="Profit ($)"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.profit}
                                size="small"
                                disabled
                                onChange={(e)=>this.props.onChangeValue(e,"profit")}
                            />
                            <TextField
                                label="Image"
                                id="outlined-size-small"
                                type={"file"}
                                size="small"
                                onChange={(e)=>this.props.onChangeValue(e,"image")}
                            />
                        </Box>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '27ch' },
                            }}
                            noValidate
                            autoComplete="true"
                        >
                            <TextField
                                label="Minimum Score"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.minScore}
                                size="small"
                                type={"number"}
                                InputProps={{
                                    inputProps: {
                                        min: 0, max: 1500000
                                    }
                                }}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"minScore")}
                            />
                            <TextField
                                label="Maximum Score"
                                id="outlined-size-small"
                                value={this.props.propsRequestValues.maxScore}
                                size="small"
                                type={"number"}
                                InputProps={{
                                    inputProps: {
                                        min: 1, max: 1500000
                                    }
                                }}
                                required
                                onChange={(e)=>this.props.onChangeValue(e,"maxScore")}
                            />
                            <FormControlLabel
                                control={<Checkbox value={this.props.propsRequestValues.idVerified} />}
                                label="ID Verified"
                                onChange={(e)=>this.props.onChangeValue(e,"idVerified")}
                            />
                            <FormControlLabel
                                control={<Checkbox value={this.props.propsRequestValues.addressVerified} />}
                                label="Address Verified"
                                onChange={(e)=>this.props.onChangeValue(e,"addressVerified")}
                            />
                            <FormControlLabel
                                control={<Checkbox value={this.props.propsRequestValues.incomeVerified} />}
                                label="Income Verified"
                                onChange={(e)=>this.props.onChangeValue(e,"incomeVerified")}
                            />
                            <FormControlLabel
                                control={<Checkbox value={this.props.propsRequestValues.isConnected} />}
                                label="Connected"
                                onChange={(e)=>this.props.onChangeValue(e,"isConnected")}
                            />
                        </Box>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '55ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Reason"
                                    multiline
                                    rows={3}
                                    onChange={(e)=>this.props.onChangeValue(e,'comment')}
                                    value={this.props.propsRequestValues.comment}
                                />
                            </div>
                        </Box>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '55ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <Typography variant="subtitle1" gutterBottom>
                                Proposed Amount : $<span>{this.props.propsRequestValues.amount}</span>
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                Fee (1.5% of proposed amount): $<span>{this.props.propsRequestValues.fee}</span>
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom color={"#800020"}>
                                Total Due : $<span>{this.props.propsRequestValues.totalDue}</span>
                            </Typography>
                            {(this.props.propsRequestValues.postedBalance - this.props.propsRequestValues.totalDue) >= 0?
                                <Typography variant="subtitle1" gutterBottom>
                                    Posted Balance : $<span>{this.props.propsRequestValues.postedBalance}</span>
                                </Typography>:
                                <Typography variant="subtitle1" gutterBottom color={"#800020"}>
                                    Not enough Fund : $<span>{this.props.propsRequestValues.postedBalance}</span>
                                </Typography>
                            }
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>Cancel</Button>
                        {(this.props.propsRequestValues.postedBalance - this.props.propsRequestValues.totalDue) >= 0?
                            <Button onClick={this.submitProposal} autoFocus>
                                Post
                            </Button>:
                            <Button disabled autoFocus>
                                Post
                            </Button>
                        }
                    </DialogActions>
                </Dialog>
            </Fragment>
        )
    }
}
export default PostComponent

/*


        <div className="card">
            <div className="postInputGroup">
                <div className="postInputGroup-pic">
                    <img src={props.profile.avatar} alt="" />
                </div>
                <div className="postInputGroup-input">
                    <input type="text" placeholder="What would you like to do today?"/>
                </div>
            </div>
            <div className="">
                <div>
                    <NavLink to="/request">
                        <img src={request} alt='<a href="https://www.flaticon.com/free-icons/askcom" title="ask.com icons">Ask.com icons created by sonnycandra - Flaticon</a>"' />
                        <span>
                        Request
                    </span>
                    </NavLink>
                </div>
                <div>
                    <NavLink to="/profile/create">
                        <img src={propose} alt='<a href="https://www.flaticon.com/free-icons/proposal" title="proposal icons">Proposal icons created by juicy_fish - Flaticon</a>'/>
                        <span>
                        Propose
                    </span>
                    </NavLink>
                </div>
            </div>
        </div>
 */